module.exports = __webpack_public_path__ + "img/icon-Cal-Outlook.a74ad5b8.png";